import { useQuery } from '@tanstack/react-query'

import { Constant } from '@/types/constant'
import { QUERY_KEY_CONSTANT } from '@/types/constants.ts'
import { authenticatedApi } from '@/utils/api.ts'

async function getConstant({ id }: { id: string }) {
  return authenticatedApi.get(`constant/${id}`).json<Constant>()
}

export const useConstant = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: [QUERY_KEY_CONSTANT, id],
    queryFn: () => getConstant({ id }),
  })
}

async function getConstants({ ids }: { ids: string[] }): Promise<Record<string, Constant>> {
  const qs = ids.join(',')
  return authenticatedApi.get(`constant`, { searchParams: { ids: qs } }).json<Record<string, Constant>>()
}

export const useConstants = ({ ids, enabled = true }: { ids: string[]; enabled?: boolean }) => {
  return useQuery({
    queryKey: [QUERY_KEY_CONSTANT, 'bulk', ids],
    queryFn: () => getConstants({ ids }),
    enabled: enabled && ids.length > 0,
  })
}
